import React from "react";
import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Col, DatePicker} from "antd";
import {timeRangeOptionsStatistics} from "../../../../../constants/constants";
import {RangePickerContainer, SelectField, Wrapper} from "./TimeRangeFilter.styles";

export const TimeRangeFilter = ({
    dateType,
    selectFieldOnChange,
    rangePickerOnChange,
    isOrdersPage = false
}) => {
    const {RangePicker} = DatePicker;
    const {t} = useTranslation(["timeRangeOptionsStatistics"]);

    return useObserver(() => (
        <Wrapper isOrdersPage={isOrdersPage}>
            {rangePickerOnChange ? (
                <Col xs={20} sm={16} md={12} lg={8} xl={6} span={4}>
                    {isOrdersPage && <h5 style={{whiteSpace: "nowrap"}}>Tarih Aralığı</h5>}
                    <SelectField
                        data-testid="timeRangeSelect"
                        value={dateType}
                        onChange={value => {
                            selectFieldOnChange(value);
                        }}
                    >
                        {timeRangeOptionsStatistics.map((obj, i) => (
                            <SelectField.Option
                                key={i}
                                data-testid="timeRangeSelect_option"
                                value={obj.value}
                            >
                                {t(obj.translation_key, {
                                    ns: "timeRangeOptionsStatistics"
                                })}
                            </SelectField.Option>
                        ))}
                    </SelectField>
                </Col>
            ) : null}
            <Col>
                {dateType === "choose" && (
                    <RangePickerContainer>
                        <RangePicker
                            data-testid="timeRangePicker"
                            renderExtraFooter={() =>
                                t("timeRangePickerPlaceholder", {ns: "common"})
                            }
                            onChange={(values, formatString, info) => {
                                rangePickerOnChange(formatString);
                            }}
                        />
                    </RangePickerContainer>
                )}
            </Col>
        </Wrapper>
    ));
};
